import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { CoverImage } from "@/components";
import Image from "@/assets/cover/challenges_elgiganten_cover.webp";
import RaffleUITCL from "@/features/raffle/components/raffle.ui.tcl";

const TCLRafflePage: FC = (): JSX.Element => {
  // Page Document Title
  useDocumentTitle("Raffle");

  return (
    <>
      <CoverImage
        src={Image}
        alt="CoverImage"
        heading="Find a winner of the TCL Time Trial Challenge."
        desc="Click the button to find a random winner."
      />
      <RaffleUITCL />
    </>
  );
};

export default TCLRafflePage;
